import type { RouteObject } from 'react-router'
import Error404Page from '@/pages/Error404'
import { authRoutes } from './auth'
import { dashboardRoutes } from './dashboard'
import { backofficeRoutes } from './backoffice'

export const routes: RouteObject[] = [
  ...authRoutes,
  ...dashboardRoutes,
  ...backofficeRoutes,
  {
    path: '*',
    element: <Error404Page />,
    handle: {
      documentTitle: { namespace: 'nav', key: 'error' },
    },
  },
]
